import { Protected } from "@stardeck-customer-apps/project-auth";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import AdminDashboard from "@/pages/admin/dashboard";
import CompaniesPage from "@/pages/companies";
import ContactsPage from "@/pages/contacts";
import Dashboard from "@/pages/dashboard";
import { Home } from "@/pages/home";
import LeadsPage from "@/pages/leads";
import Login from "@/pages/login";
import { NotFound } from "@/pages/not-found";
import ReportsPage from "@/pages/reports";

import { Providers } from "./providers";

function AppRoutes() {
  return (
    <Router>
      <Providers>
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/contacts" element={<ContactsPage />} />
            <Route path="/companies" element={<CompaniesPage />} />
            <Route path="/leads" element={<LeadsPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route
              path="/admin"
              element={
                <Protected redirectTo="/login">
                  <AdminDashboard />
                </Protected>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </Providers>
    </Router>
  );
}

export default AppRoutes;
